module.exports = __webpack_public_path__ + "img/cancel.7a547f81.svg";